import { ApiResponse } from "../../../types";
import { deleteRequestWithAuth, getRequestWithAuth, patchRequestWithAuth, postRequestWithAuth } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";
import { User } from "../../../types/user.type";

const api = getApiWithVersion(API_VERSION.V1);

export interface FetchUserApiResponse {
 
    status: boolean;
    msg: string;
    result: User;
}


export interface RemoveOtpResponse {
  send: boolean;
  mobile_no: string;
}

export interface DeleteUserResponse {
  mobile_no: string | null;
}

export interface API_User {
  fetchUserData(user_id: number): Promise<ApiResponse<FetchUserApiResponse>>;
    sendRemoveOtp(user_id: number): Promise<ApiResponse<RemoveOtpResponse>>;
      deleteUser(user_id: number): Promise<ApiResponse<DeleteUserResponse>>;

       updateUser(
    payload: { name: string; email: string },
    user_id: string | number
  ): Promise<ApiResponse<any>>;


}

const user: API_User = {
  fetchUserData(user_id) {
    return getRequestWithAuth(api.FETCH_USER, user_id);
  },


  deleteUser(user_id) {
    return deleteRequestWithAuth(api.DELETE_USER, user_id);
  },

    updateUser(payload, user_id) {
    return patchRequestWithAuth(api.UPDATE_USER, payload, user_id);
  },

  sendRemoveOtp(user_id) {
    return postRequestWithAuth(
      api.REMOVE_USER_OTP,
      {}, 
      user_id
    );
  }
};

export default user;
